module.exports = __webpack_public_path__ + "media/images/pc/articles/report_03-1e8ac62ad41d0333ed62c4eaf84f5bee.webp";